import { Link } from '@sitecore-jss/sitecore-jss-react';
import PropTypes from 'prop-types';
import { t } from 'i18next';
import React, { PureComponent } from 'react';
import {
  SubNavigationGroup, SubNavigationGroupItem, SubNavigationGroupContainer, SubNavItemName,
} from './css';
import ChevronIcon from '../../assets/icons/chevron_icon.svg';

class NavigationGroup extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      isMenuOpen: false,
    };
  }

  toggleMenu = () => this.setState((prevState) => ({ isMenuOpen: !prevState.isMenuOpen }));

  openMenu = () => this.setState(() => ({ isMenuOpen: true }));

  render() {
    const { section: { children, title } = {} } = this.props;

    return (
      <SubNavigationGroupContainer $isOpen={this.state.isMenuOpen}>
        <SubNavItemName
          onClick={() => this.toggleMenu()}
          tabIndex={0}
          onFocus={() => this.openMenu()}
          onMouseDown={(e) => e.preventDefault()}
        >
          <p>{title.value}</p>
          <img alt={t('MoreOptions')} src={ChevronIcon} aria-label={t('MoreOptions')} />
        </SubNavItemName>
        <SubNavigationGroup>
          {children.map((c) => (
            <SubNavigationGroupItem key={c.id}>
              <Link field={c.link.jss} to="#" />
            </SubNavigationGroupItem>
          ),
          )}
        </SubNavigationGroup>
      </SubNavigationGroupContainer>
    );
  }
}

NavigationGroup.propTypes = {
  section: PropTypes.shape({
    title: PropTypes.object,
    children: PropTypes.array,
  }),
};

export default NavigationGroup;
